export default __webpack_public_path__ + "static/media/colocado-1-thumb.1bfd4e80.jpg";